export enum BundleTypeEnum {
  OFFER = 'offer',
  PREPAID = 'prepaid',
  ACCESSORY = 'accessory',
  ADDITIONAL_OFFER = 'additionalOffer',
}
